"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dateDiffInDays = exports.convertDurationToString = void 0;
exports.formatTime = formatTime;
exports.isValidDate = isValidDate;
var _MS_PER_DAY = 1000 * 60 * 60 * 24;
var convertDurationToString = (duration, options) => {
  var {
    hours = true,
    minutes = true,
    seconds = true,
    separator = ':',
    hideHoursIfnull = false,
    hideMinutesIfnull = false,
    hideSecondesIfnull = false,
    separatorHours = separator,
    separatorMinutes = separator,
    separatorSeconds = ''
  } = options || {};
  var durationInSec = duration > 0 ? duration / 1000 : 0;
  var secondsTxt = '';
  var minutesTxt = '';
  var hoursTxt = '';
  if (seconds) {
    var secsValue = Math.floor(!minutes && !hours ? durationInSec : durationInSec % 60);
    secondsTxt = hideSecondesIfnull && !secsValue ? '' : secsValue.toString().padStart(2, '0');
  }
  if (minutes) {
    var minsValue = Math.floor(!hours ? durationInSec / 60 : durationInSec / 60 % 60);
    minutesTxt = hideMinutesIfnull && !minsValue ? '' : minsValue.toString().padStart(2, '0');
  }
  if (hours && minutes) {
    var hoursValue = Math.floor(durationInSec / 3600);
    hoursTxt = hideHoursIfnull && !hoursValue ? '' : hoursValue.toString().padStart(2, '0');
  }
  if (hoursTxt && minutesTxt) hoursTxt = "".concat(hoursTxt).concat(separatorHours);
  if (minutesTxt && secondsTxt) minutesTxt = "".concat(minutesTxt).concat(separatorMinutes);
  if (secondsTxt) secondsTxt = "".concat(secondsTxt).concat(separatorSeconds);
  return "".concat(hoursTxt).concat(minutesTxt).concat(secondsTxt);
};
exports.convertDurationToString = convertDurationToString;
var dateDiffInDays = (a, b) => {
  if (!isValidDate(a) || !isValidDate(b)) return 0;

  // Discard the time and time-zone information.
  var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
  return Math.floor((utc2 - utc1) / _MS_PER_DAY);
};
exports.dateDiffInDays = dateDiffInDays;
function isValidDate(date) {
  return !!date && Object.prototype.toString.call(date) === '[object Date]' && !isNaN(Number(date));
}
function formatTime(now) {
  var hh = now.getHours().toString().padStart(2, '0');
  var mm = now.getMinutes().toString().padStart(2, '0');
  var ss = now.getSeconds().toString().padStart(2, '0');
  var ms = now.getMilliseconds().toString().padStart(3, '0');
  var nowString = "".concat(hh, ":").concat(mm, ":").concat(ss, ".").concat(ms, " - ");
  return nowString;
}